import { MultiSelectOptionProps } from '@la/ds-ui-components';
import { Division } from '@la/types';
import { TeamSelection } from '../../../../Wizard.types';
import { getNumberOfSpotsLeft } from '../../utils/capacity';

export const getAtCapacityDisabledReason = (subProgramLabel: string) =>
  `You have selected the maximum number of teams allowed for this ${subProgramLabel}.`;

export const isDivisionAtCapacity = (
  division: Division,
  teamSelections: TeamSelection[]
): boolean => {
  const numberOfSpotsLeft = getNumberOfSpotsLeft(division);
  return (
    numberOfSpotsLeft !== undefined &&
    teamSelections.filter(({ teamId }) => teamId.length).length >=
      numberOfSpotsLeft
  );
};

export const disableTeamForAtCapacity = (
  teamOption: MultiSelectOptionProps,
  selections: TeamSelection[],
  atCapacityDisabledReason: string
): MultiSelectOptionProps => {
  return {
    ...teamOption,
    disabled:
      !teamOption.checkboxState ||
      !!selections.find(
        (teamSelection) => teamSelection.teamId === teamOption.value
      ),
    disabledReason: teamOption.disabled
      ? teamOption.disabledReason
      : atCapacityDisabledReason,
  };
};

export const enableTeamForAtCapacity = (
  teamOption: MultiSelectOptionProps,
  atCapacityDisabledReason: string
): MultiSelectOptionProps => {
  return {
    ...teamOption,
    disabled:
      teamOption.disabledReason === atCapacityDisabledReason
        ? false
        : teamOption.disabled,
    disabledReason:
      teamOption.disabledReason === atCapacityDisabledReason
        ? undefined
        : teamOption.disabledReason,
  };
};
